var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrationTest = function SvgIntegrationTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.55 61.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.55,
    y: 8.5,
    width: 53,
    height: 53,
    rx: 8.1,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.44,54h35.82c.96,0,1.73-.78,1.73-1.73V3.73c0-.96-.78-1.73-1.73-1.73H3.73c-.96,0-1.73.78-1.73,1.73v35.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.22,10.67h23.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.67,10.67h2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.44,52.56l24.56-24.56M28,28v11.56M28,28h-11.56"
  }))));
};
export default SvgIntegrationTest;